/**
 * COMPLETE canonical list of Indian States + Union Territories — all 28 states + 8 UTs (36 total).
 *
 * This is the authoritative list for location dropdowns. It is intentionally SEPARATE from and
 * MORE COMPLETE than `INDIAN_STATES` in `src/lib/i18n.ts` (which is missing several UTs — Andaman &
 * Nicobar, Chandigarh, Dadra & Nagar Haveli and Daman & Diu, Lakshadweep, Puducherry). New code
 * should import THIS const. `INDIAN_STATES` is retained for now because other modules still import it.
 *
 * Copied from the inline `states` array in src/app/onboard/page.tsx (verified: 28 states + 8 UTs),
 * pre-sorted alphabetically so consumers can render it directly without a runtime `.sort()`.
 * Typed as string[] (not `as const`) so it works for both `.map()` (dropdowns) and `.includes(str)`
 * (e.g. onboard's reverse-geocode match) — making a future dedup of the inline copies zero-risk.
 */
export const INDIAN_STATES_COMPLETE: string[] = [
  'Andaman & Nicobar Islands',
  'Andhra Pradesh',
  'Arunachal Pradesh',
  'Assam',
  'Bihar',
  'Chandigarh',
  'Chhattisgarh',
  'Dadra & Nagar Haveli and Daman & Diu',
  'Delhi',
  'Goa',
  'Gujarat',
  'Haryana',
  'Himachal Pradesh',
  'Jammu & Kashmir',
  'Jharkhand',
  'Karnataka',
  'Kerala',
  'Ladakh',
  'Lakshadweep',
  'Madhya Pradesh',
  'Maharashtra',
  'Manipur',
  'Meghalaya',
  'Mizoram',
  'Nagaland',
  'Odisha',
  'Puducherry',
  'Punjab',
  'Rajasthan',
  'Sikkim',
  'Tamil Nadu',
  'Telangana',
  'Tripura',
  'Uttar Pradesh',
  'Uttarakhand',
  'West Bengal',
]
